export default __webpack_public_path__ + "c2761ffb4a82c286bcdb45cc17efd526.png";